export const CATALOG_INVENTORY_ORIGIN = {
  ContentServer: 'ContentServer',
  CustomerGenerated: 'CustomerGenerated',
  AppPromote: 'AppPromote',
};

const CATALOG_INVENTORY_ORIGIN_MAPPING = [
  { value: CATALOG_INVENTORY_ORIGIN.ContentServer, label: 'Content Server' },
  { value: CATALOG_INVENTORY_ORIGIN.CustomerGenerated, label: 'Customer Generated' },
  { value: CATALOG_INVENTORY_ORIGIN.AppPromote, label: 'App Promote' },
];

export const getCatalogInventoryOriginLabel = value =>
  CATALOG_INVENTORY_ORIGIN_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getCatalogInventoryOriginOptions = () =>
  CATALOG_INVENTORY_ORIGIN_MAPPING.map(({ value, label }) => ({ value, label }));
